import type { EvaluationContext } from '@openfeature/react-sdk';

export const ANONYMOUS_USER_KEY = 'anonymous-user';

export type FeatureFlagSingleContext = {
  key: string;
  email?: string;
};

export type FeatureFlagContext = EvaluationContext;

type BuildFeatureFlagContextInput = {
  userId?: string | null;
  email?: string | null;
  companyId?: string | null;
};

export function buildFeatureFlagContext({
  userId,
  email,
  companyId,
}: BuildFeatureFlagContextInput): FeatureFlagContext {
  if (!userId) {
    return {
      kind: 'user',
      key: ANONYMOUS_USER_KEY,
      anonymous: true,
    };
  }

  const userContext: FeatureFlagSingleContext = {
    key: userId,
    ...(email ? { email } : {}),
  };

  if (!companyId) {
    return {
      kind: 'user',
      ...userContext,
    };
  }

  return {
    kind: 'multi',
    user: userContext,
    company: {
      key: companyId,
    },
  };
}
